import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ComponentRendering, Item } from '@sitecore-jss/sitecore-jss/layout';
import {
  FormFieldsGeneratorService,
  FormFields
} from './../../../shared/services/form-fields-generator.service';
import { DataSubscriptionService } from './../../../shared/services/data-subscription.service';
import {
  /*ReportingRequest, */ REPORTING_EVENTS,
  ReportingService
} from './../../services/reporting.service';
import * as moment from 'moment';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'ab-audit-report-search',
  templateUrl: './audit-report-search.component.html',
  styleUrls: ['./audit-report-search.component.scss']
})
export class AuditReportSearchComponent implements OnInit {
  @Input() rendering: ComponentRendering;

  public formFields: FormFields;
  public toDateMax = new Date();
  public fromDateMax: moment.Moment = moment();
  public fromDateMin: moment.Moment = moment()
    .year(1950)
    .month(0)
    .date(1);
  public selectedReportType: string;
  public pageNumber: number;
  public searchForm: UntypedFormGroup;
  public page = 0;
  public hasMore = false;
  public isLoading = false;
  public showNoFound = false;
  public noFound: Item;
  public isFileDownloading = false;

  constructor(
    private reportingService: ReportingService,
    private formFieldsGeneratorService: FormFieldsGeneratorService,
    private dataSubscriptionService: DataSubscriptionService,
    private cookieService: CookieService
  ) {}

  ngOnInit() {
    this.formFields = this.formFieldsGeneratorService.generateFormFields(
      this.rendering
    ) as FormFields;

    this.dataSubscriptionService.initOnScroll(() => this.onScroll());

    this.searchForm = new UntypedFormGroup({
      fromDate: new UntypedFormControl(moment().subtract(30, 'days'), []),
      toDate: new UntypedFormControl(moment(), []),
      selectedReportType: new UntypedFormControl(
        (this.formFields.fields.select.values[0] as any).fields.Value.value,
        []
      ),
      selectedReportFormat: new UntypedFormControl(
        (this.formFields.fields.selectFormat
          .values[0] as any).fields.Value.value,
        []
      )
    });
    (this.rendering.fields.items as Item[]).some(o => {
      if (o.name === 'NoFound') {
        this.noFound = o;
        return true;
      }

      return false;
    });
  }

  get fromDateField() {
    return this.searchForm.get('fromDate');
  }

  get toDateField() {
    return this.searchForm.get('toDate');
  }

  get toDateMin() {
    if (this.fromDateMax.isAfter(this.fromDateField.value)) {
      return this.fromDateField.value;
    }

    return this.fromDateMin;
  }

  onScroll(): void {
    this.page++;
    this.dataSubscriptionService.publishEvent(REPORTING_EVENTS.SCROLLING);
    this.getReport(false);
  }

  onSubmit(): void {
    if (this.searchForm.valid) {
      this.page = 0;
      this.isLoading = true;
      this.dataSubscriptionService.publishEvent(REPORTING_EVENTS.SEARCHING);
      this.getReport(true);
    }
  }

  getReport(afterSubmit: boolean): void {
    this.reportingService.getReport(this.searchForm.value, this.page).subscribe(
      response => {
        this.stopLoading();
        this.hasMore = response.items.length !== 0;

        if (this.page === 0) {
          this.showNoFound = !this.hasMore;
        } else {
          this.showNoFound = false;
        }

        this.publishData(response, afterSubmit);
      },
      error => {
        console.error(error);
        this.stopLoading();
      }
    );
  }

  publishData(response, afterSubmit: boolean): void {
    const data = Object.assign(response);
    data.page = this.page;
    data.title = this.getTitle();
    data.hasMore = this.hasMore;
    data.afterSubmit = afterSubmit;

    this.dataSubscriptionService.publishData(
      this.searchForm.value.selectedReportType === 'SignInLog'
        ? REPORTING_EVENTS.SIGN_IN
        : REPORTING_EVENTS.MONEY_TRANSFER,
      data
    );
  }

  getTitle(): string {
    const arr = this.formFields.fields.select.values.filter((item: any) => {
      return (
        item.fields.Value.value === this.searchForm.value.selectedReportType
      );
    });

    return (arr[0] as any).fields.Label.value;
  }

  public download(): void {
    if (this.searchForm.valid) {
      this.isFileDownloading = true;

      const interval = setInterval(() => {
        if (
          this.cookieService.check('reportFileType') &&
          this.searchForm.get('selectedReportType').value ===
            this.cookieService.get('reportFileType')
        ) {
          this.cookieService.set('reportFileType', '0', null, '/', null, true);
          this.isFileDownloading = false;
          clearInterval(interval);
        }
      }, 500);

      window.location.href = this.reportingService.download(
        this.searchForm.value
      );
    }
  }

  private stopLoading() {
    this.isLoading = false;
    this.dataSubscriptionService.publishEvent(REPORTING_EVENTS.STOP_LOADING);
  }
}
